const numberTag = {
  0: 'Landline',
  1: 'Cellphone',
  2: 'Whatsapp',
};

export { numberTag };
